import { HomePageData } from '../types/home';

export const mockHomeData: HomePageData = {
  emotionalStates: [
    { id: 1, icon: '😟', label: 'Мне тревожно', state: 'anxiety' },
    { id: 2, icon: '😔', label: 'Я в депрессии!', state: 'depression' },
    { id: 3, icon: '😵', label: 'У меня стресс', state: 'stress' },
    { id: 4, icon: '😢', label: 'Мне грустно', state: 'depression' },
    { id: 5, icon: '💤', label: 'Не могу заснуть', state: 'anxiety' },
    { id: 6, icon: '⚡️', label: 'Срочная помощь', state: 'anxiety' }
  ],
  popularTopics: [
    { 
      id: 1, 
      icon: '💡', 
      title: 'Как справиться с тревогой',
      description: 'Практические техники для управления тревогой',
      category: 'anxiety',
      slug: 'anxiety-management',
      html_content: '<h1>Как справиться с тревогой</h1><p>Практические техники для управления тревогой</p>'
    },
    { 
      id: 2, 
      icon: '💔', 
      title: 'Как пережить расставание',
      description: 'Способы преодоления эмоциональной боли',
      category: 'relationships',
      slug: 'breakup-recovery',
      html_content: '<h1>Как пережить расставание</h1><p>Способы преодоления эмоциональной боли</p>'
    },
    { 
      id: 3, 
      icon: '🏋️', 
      title: 'Как повысить уверенность в себе',
      description: 'Упражнения для развития самооценки',
      category: 'self-development',
      slug: 'self-confidence',
      html_content: '<h1>Как повысить уверенность в себе</h1><p>Упражнения для развития самооценки</p>'
    },
    { 
      id: 4, 
      icon: '🛌', 
      title: 'Как справиться с бессонницей',
      description: 'Техники для здорового сна',
      category: 'sleep',
      slug: 'insomnia-management',
      html_content: '<h1>Как справиться с бессонницей</h1><p>Техники для здорового сна</p>'
    },
    { 
      id: 5, 
      icon: '🎯', 
      title: 'Как перестать прокрастинировать',
      description: 'Методы повышения продуктивности',
      category: 'productivity',
      slug: 'stop-procrastination',
      html_content: '<h1>Как перестать прокрастинировать</h1><p>Методы повышения продуктивности</p>'
    }
  ],
  audioPractices: [
    { 
      id: 1, 
      icon: '🫁', 
      title: 'Дыхательная практика для тревоги',
      description: '',
      duration: 300,
      duration_formatted: '05:00',
      audio_file: '/audio/breathing-anxiety.mp3',
      category: 'anxiety'
    },
    { 
      id: 2, 
      icon: '🌊', 
      title: 'Медитация "Безопасное место"',
      description: '',
      duration: 600,
      duration_formatted: '10:00',
      audio_file: '/audio/safe-place.mp3',
      category: 'meditation'
    },
    { 
      id: 3, 
      icon: '🎵', 
      title: 'Музыка для расслабления',
      description: '',
      duration: 900,
      duration_formatted: '15:00',
      audio_file: '/audio/relaxation.mp3',
      category: 'music'
    },
    { 
      id: 4, 
      icon: '🔄', 
      title: 'Техника заземления (5-4-3-2-1)',
      description: '',
      duration: 450,
      duration_formatted: '07:30',
      audio_file: '/audio/grounding.mp3',
      category: 'anxiety'
    }
  ],
  courses: [
    { 
      id: 1, 
      title: 'Курс "Тело и эмоции"', 
      description: 'Научитесь понимать и управлять своими эмоциями',
      type: 'аудио/видео',
      duration: 3600,
      duration_formatted: '01:00:00',
      lessons_count: 12,
      image: '/images/courses/body-emotions.jpg',
      category: 'emotions'
    },
    { 
      id: 2, 
      title: 'Как перестать зависеть от чужого мнения',
      description: 'Развитие здоровой самооценки и независимости',
      type: 'видео',
      duration: 7200,
      duration_formatted: '02:00:00',
      lessons_count: 8,
      image: '/images/courses/self-esteem.jpg',
      category: 'self-development'
    },
    { 
      id: 3, 
      title: 'Как вернуть радость жизни',
      description: 'Практики для повышения уровня счастья',
      type: 'аудио/видео',
      duration: 5400,
      duration_formatted: '01:30:00',
      lessons_count: 10,
      image: '/images/courses/happiness.jpg',
      category: 'happiness'
    }
  ],
  searchSuggestions: [
    { id: 1, text: 'Как справиться с тревогой' },
    { id: 2, text: 'Как пережить расставание' },
    { id: 3, text: 'Как повысить уверенность в себе' },
    { id: 4, text: 'Как справиться с бессонницей' },
    { id: 5, text: 'Как перестать прокрастинировать' }
  ]
}; 